import {lazyComponent} from 'coreUtils/adapters/lazy';

const SavedPaymentCardPopup = lazyComponent(() => import('./SavedPaymentCardPopup'));

export {SavedPaymentCardPopup as default};
